<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="center-main-content">
            <div class="top-day-area">
                <!-- <div class="calendar-box">
            <button class="prev" @click="onClickBtnPrevMonth"></button>
            <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
            <button class="next" @click="onClickBtnNextMonth"></button>
        </div> -->
                <div class="today-box">
                    <span class="day">{{ startDate }} {{ formatDay(startDate) }}</span>
                </div>
            </div>
            <div class="info-link-area">
                <div class="box" v-if='hasAuth'>
                    <router-link to="/madmin/sales/all">오늘의 매출 현황 <span>❯</span></router-link>
                    <span class="info-cnt">
                        <span class="num">{{ todaySalePrice | numberFormatFilter }}</span>
                        <!--  <span class="num" v-show="!hasAuth">0</span>-->
                        <span class="txt">원</span>
                    </span>
                </div>
                <div class="box">
                    <router-link to="/madmin/schedule/day">오늘의 수업 <span>❯</span></router-link>
                    <span class='date'>{{ moment().format('yyyy.MM.DD') }} 기준</span>
                    <span class="info-cnt">
                        <span class="num">개인({{todayLessonStat['P'] || 0}}) 듀엣({{todayLessonStat['D'] || 0}}) 그룹({{todayLessonStat['G'] || 0}})</span>
                    </span>
                </div>
                <div class="box">
                    <router-link
                        :to="{
                            path: `/madmin/course/care`,
                            query: { remainDays: 30 }
                        }"
                    >
                        만료예정 30일이내 회원 <span>❯</span>
                    </router-link>
                    <span class='date'>{{ moment().format('yyyy.MM.DD') }} 기준</span>
                    <span class="info-cnt">
                        <span class="num">{{ expiringMemberCount }}</span>
                        <span class="txt">명</span>
                    </span>
                </div>
                <div class="box">
                    <router-link
                        :to="{
                            path: `/madmin/member/list`,
                            query: { inactiveDays: 14 }
                        }"
                    >
                        14일 이상 미예약 회원 <span>❯</span>
                    </router-link>
                    <span class='date'>{{ moment().format('yyyy.MM.DD') }} 기준</span>
                    <span class="info-cnt">
                        <span class="num">{{ inactiveUserCount }}</span>
                        <span class="txt">명</span>
                    </span>
                </div>

                <div class="box attendance">
                    <component
                        :is="isAllowed('ME', 8) ? 'router-link' : 'a'"
                        :to="{
                            path: `/madmin/history/attendance`,
                            query: { t: moment().valueOf() }
                        }"
                    >
                        출석왕 회원 <span>❯</span>
                    </component>
                    <span class='date'>{{ moment().format('yyyy.MM.DD') }} 기준</span>
                    <div class="info-cnt">
                        <div v-for='(stat, index) in attendanceStat'>
                            <span class="txt">{{ index + 1 }}위 </span>
                            <span v-if='stat.name'>{{ stat.name }} ({{stat.total_count}}회)</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="info-area">
                <div class="box">
                    <div class="top-cnt">
                        <router-link to="/madmin/course/care">이용권 등록현황 &gt;</router-link>
                        <span class="info">
                            <span class="txt">총 {{ ticketCount }}건</span>
                            <!-- <span class="num">{{ticketPrice | numberFormatFilter}} <small>원</small></span> -->
                        </span>
                    </div>
                    <table class="com-table">
                        <colgroup>
                            <col style="width: 100px" />
                            <col style="width: 220px" />
                            <col style="width: 220px" />
                            <col style="width: 155px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>회원명</th>
                                <th>이용권명</th>
                                <th>유효기간</th>
                                <th>가격</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(l, index) in lessonList" :key="index">
                                <td>{{ l.cc_customer_name }}</td>
                                <td>{{ l.cc_lesson_name }}</td>
                                <td>
                                    {{ l.cc_exp_start_dt | timestampFilter }} ~ {{ l.cc_exp_end_dt | timestampFilter }}
                                </td>
                                <td>
                                    <span v-if="hasAuth">{{ l.cc_total_buy_price | numberFormatFilter }} 원</span>
                                </td>
                            </tr>
                            <tr v-if="lessonList.length == 0">
                                <td colspan="100">등록된 내용이 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="box">
                    <div class="top-cnt">
                        <router-link to="/madmin/history/reserve">예약내역 &gt;</router-link>
                        <span class="info">
                            <span class="txt">예약 {{ todayReserveCount }}건 / 취소 {{ todayCancelCount }}건</span>
                            <span class="num">
                                {{ todayReserveCount + todayCancelCount }}
                                <small>건</small>
                            </span>
                        </span>
                    </div>
                    <table class="com-table">
                        <colgroup>
                            <col style="width: 100px" />
                            <col style="width: 100px" />
                            <col style="width: 100px" />
                            <col style="width: 100px" />
                            <col style="width: 165px" />
                            <col style="width: 125px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>예약시간</th>
                                <th>강사명</th>
                                <th>회원명</th>
                                <th>이용권</th>
                                <th>수업시간</th>
                                <th>상태</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(r, index) in reservationList" :key="index">
                                <td>{{ r.cth_resv_dt | formatConvertUTCTime }}</td>
                                <td>{{ r.cs_namee }}</td>
                                <td>{{ r.cust_namee }}</td>
                                <td>{{ convertTicket(r.cp_ticket_type_cd) }}</td>
                                <td>
                                    {{ convertLessonTime(r.cth_less_dt) }} {{ r.cth_less_dt | formatConvertUTCTime }}
                                </td>
                                <td>
                                    <span
                                        :class="{
                                            'com-btn': true,
                                            blue: ['RR', 'CR', 'RW'].includes(r.cth_resv_status_cd),
                                            red: ['RC', 'CC', 'AC'].includes(r.cth_resv_status_cd),
                                        }"
                                    >
                                        {{ convertReserve(r.cth_resv_status_cd) }}
                                    </span>
                                </td>
                            </tr>
                            <tr v-if="reservationList.length == 0">
                                <td colspan="100">등록된 내용이 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="info-area">
                <div class="box">
                    <div class="top-cnt">
                        <router-link to="/madmin/history/entrance">입장내역 &gt;</router-link>
                        <span class="info">
                            <span class="txt">이용만료 {{ expireAttendNum }}명</span>
                            <span class="num">
                                {{ attendanceLength }}
                                <small>명</small>
                            </span>
                        </span>
                    </div>
                    <div class="entrance-list">
                        <ul>
                            <li v-for="(a, index) in attendanceList" :key="index" :style="testMethod(a.ccp_exp_end_dt)">
                                <template v-if="index <= 7">
                                    <div class="top-info">
                                        <span class="photo">
                                            <img :src="getImageUrl(a.cust_img_url)" alt="" />
                                        </span>
                                        <router-link
                                            :to="{
                                                path: `/madmin/member/payment/${a.ccp_center_id}`,
                                                query: { customerId: a.ccp_center_cust_id },
                                            }"
                                            class="link"
                                        >
                                            <span class="name">{{ a.cust_namee }}</span>
                                        </router-link>
                                        <span class="lesson">{{ a.cp_namee }}</span>
                                        <span class="time">{{ a.cth_entr_dt | formatConvertUTCTime }}</span>
                                    </div>
                                    <div class="day-info">
                                        <span :class="testMethod2(a.ccp_exp_end_dt)">
                                            이용권만료일 {{ a.ccp_exp_end_dt | timestampFilter }}
                                        </span>
                                        <div
                                            style="
                                                width: 1px;
                                                height: 15px;
                                                margin: 2px 3px 0;
                                                display: inline-block;
                                                background-color: #d4d4d4;
                                            "
                                        ></div>
                                        <!--                                    <span :class="testMethod2(a.ccp_exp_end_dt)">이용권만료일 {{ a.ccp_exp_end_dt | timestampFilter }}</span>-->
                                    </div>
                                </template>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="info-area">
                <div class="box">
                    <div class="top-cnt">
                        <router-link to="/madmin/notice/list">핏투데이케어 공지사항 &gt;</router-link>
                    </div>
                    <table class="com-table">
                        <colgroup>
                            <col style="width: 100px" />
                            <col style="width: 555px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>등록일</th>
                                <th>제목</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="n in noticeList" :key="n.c_id">
                                <td>{{ n.c_cre_dt | timestampFilter }}</td>
                                <td class="left">
                                    <router-link :to="`/madmin/notice/detail/${n.c_id}`" class="ic-link">
                                        <span class="icon">{{ n.c_cate_nm }}</span>
                                        <span :class="{ txt: true, new: n.c_read_yn !== true }">{{ n.c_title }}</span>
                                    </router-link>
                                </td>
                            </tr>
                            <tr v-if="noticeList.length == 0">
                                <td colspan="100">등록된 내용이 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="box">
                    <div class="top-cnt">
                        <router-link to="/madmin/board/list">업무게시판 &gt;</router-link>
                    </div>
                    <table class="com-table">
                        <colgroup>
                            <col style="width: 100px" />
                            <col style="width: 100px" />
                            <col style="width: 100px" />
                            <col style="width: 265px" />
                            <col style="width: 125px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>등록일</th>
                                <th>글쓴이</th>
                                <th>참석자</th>
                                <th>제목</th>
                                <th>진행여부</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="t in taskList" :key="t.keys">
                                <td>{{ t.cre_dt | timestampFilter }}</td>
                                <td>{{ t.writor }}</td>
                                <td>{{ t.join_staff_name }} 외 {{ t.join_staff_count }}명</td>
                                <router-link
                                    :to="`/madmin/board/detail/${t.center_id}/${t.center_task_id}`"
                                    class="ic-link"
                                >
                                    <td>{{ t.title }}</td>
                                </router-link>
                                <td>
                                    <span :class="{ blue: t.status_cd == 'C', red: t.status_cd == 'O' }">
                                        {{ convertStatus(t.status_cd) }}
                                    </span>
                                </td>
                            </tr>
                            <tr v-if="taskList.length == 0">
                                <td colspan="100">등록된 내용이 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-for="(popup, index) in popupList" :key="index">
                <Popup
                    v-if="popup.noticePop"
                    :img-url="popup.bp_file_url"
                    :title="popup.bp_title"
                    :url="popup.bp_url"
                    @close-popup="onClickPopup(index)"
                    @stop-show-today="onClickStopShowToday(popup.bp_id, index)"
                ></Popup>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import api from '@/assets/js/api';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { pagingInfo } from '@/assets/js/common';
import { mapState } from 'vuex';

export default {
    name: 'CenterMain',
    props: {},
    mixins: [MixinAllowedMenu],
    computed: {
        ...mapState({
            centerId: (state) => state.auth.user.centerId,
        }),
    },
    data() {
        return {
            pagingInfo: { ...pagingInfo },
            noticeList: [],
            taskList: [],
            attendanceList: [],
            reservationList: [],
            lessonList: '',
            startDate: moment().format('YYYY-MM-DD'),
            endDate: moment().format('YYYYMMDD'),
            todaySalePrice: 0,
            todayReservePerson: 0,
            todayExpiredCount: 0,
            todayLessonStat: {},
            expiringMemberCount: 0,
            inactiveUserCount: 0,
            attendanceStat: [],

            todayReserveCount: 0,
            todayCancelCount: 0,
            expStartDate: moment().startOf('month').format('YYYY-MM-DD'),
            expEndDate: moment().endOf('month').format('YYYY-MM-DD'),

            ticketCount: 0,
            ticketPrice: 0,

            attendanceLength: 0,
            expireAttendNum: 0,
            lockerCount: 0,

            popupList: [],
            hasAuth: false,

            count: 0,
        };
    },
    watch: {
        centerId(val) {
            this.initStartDate();
            this.init();
        },
        startDate(newValue) {
            // 검색 시작일
            this.startDate = newValue;
            this.endDate = newValue;
            this.expStartDate = moment(newValue).startOf('month').format('YYYY-MM-DD');
            this.expEndDate = moment(newValue).endOf('month').format('YYYY-MM-DD');
            if (this.count > 0) {
                this.init(); // 날찌변경후 재조회
            } else {
                this.count += 1;
            }
        },
    },
    mounted() {
        this.initStartDate(); // 검색 시작일 초기화
        this.init();

        setTimeout(() => {
            const testbool = this.isAllowed('SA', 2) && this.isAllowed('SA', 1);
            if (testbool) {
                this.hasAuth = true;
            }
        }, 200);
    },
    methods: {
        moment: function () {
            return moment();
        },

        init() {
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 5;
            // 게시판 공지사항, '', 입장내역, 예약내역, 오늘의 예약인원, 수업내역, 오늘의 매출내역, 만료 예정 건수 조회, ''
            Promise.all([
                this.onNoticeList(),
                this.onTaskList(),
                this.onAttendanceList(),
                this.onReservationList(),
                this.fetchTodayLessonStat(),
                this.onLessonList(),
                this.todaySaleStatus(),
                this.getLessonCountByRemainDays(30),
                this.getInactiveUserCount(14),
                this.fetchAttendanceStat(),
                this.fetchPopupList(),
            ]);
        },
        async onNoticeList() {
            try {
                const { data } = await this.getNoticeList();
                this.noticeList = data.items;
            } catch (error) {}
        },
        getNoticeList() {
            return api.get('/admin/api/ft/board/notice', {
                params: {
                    ...this.pagingInfo,
                },
            });
        },
        async onTaskList() {
            try {
                const { data } = await this.getTaskList();
                this.taskList = data.items;
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        getTaskList() {
            return api.get('/admin/api/centerTask/all', {
                params: {
                    centerId: this.centerId,
                    ...this.pagingInfo,
                },
            });
        },
        // 입장내역
        async onAttendanceList() {
            try {
                const { data } = await this.getAttendanceList();
                this.attendanceList = [];
                for (const index in data.items) {
                    if (index < 8) this.attendanceList.push(data.items[index]);
                    if (this.testMethod3(data.items[index].ccp_exp_end_dt)) this.expireAttendNum++;
                }
                this.attendanceLength = data.items.length;
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        getAttendanceList() {
            return api.get(`/admin/api/center/${this.centerId}/lesson/schedule/customer/attendance/all`, {
                params: {
                    // ...this.pagingInfo,
                    // startDate:20210101,
                    // endDate:20211231,
                    page: 1,
                    limit: 999,
                    attendanceDevice: 'TU',
                    startDate: moment(this.startDate).format('YYYYMMDD'),
                    endDate: moment(this.startDate).format('YYYYMMDD'),
                },
            });
        },
        // 예약내역
        async onReservationList() {
            try {
                const { data } = await this.getReservationList(); // 예약내역 조회
                this.todayReserveCount = 0; // 초기화
                this.todayCancelCount = 0; // 초기화
                if (data.items.length > 0) {
                    this.reservationList = data.items.slice(0, 5);
                    data.items.forEach((g) => {
                        if (g.cth_resv_status_cd == 'RR') {
                            // 예약
                            this.todayReserveCount += 1;
                        } else if (g.cth_resv_status_cd == 'RC') {
                            // 예약취소
                            this.todayCancelCount += 1;
                        }
                    });
                } else {
                    this.reservationList = [];
                }
            } catch (error) {
                console.log(error);
            }
        },
        // 예약내역
        getReservationList() {
            return api.get(`/admin/api/center/${this.centerId}/lesson/schedule/customer/reservation/all`, {
                params: {
                    page: 1,
                    limit: 1000,
                    searchDateType: 'S', // 예약타입 고정(예약시간)
                    startDate: moment(this.startDate).format('YYYYMMDD'),
                    endDate: moment(this.startDate).format('YYYYMMDD'),
                },
            });
        },
        // 오늘의 예약인원
        async onTodayReservationNumber() {
            const { data } = await this.fetchReservationList(); // 오늘의 예약인원
            this.todayReservePerson = data.membercount;
        },
        // 오늘의 예약인원
        fetchReservationList() {
            //
            return api.get(`/admin/api/dash/board/today/reservation/${this.centerId}`, {
                params: {
                    applyDate: moment(this.startDate).format('YYYYMMDD'),
                },
            });
        },
        // 수업리스트
        async onLessonList() {
            try {
                const { data } = await this.getLessonList();
                this.lessonList = [];
                for (const i in data.items) {
                    if (i >= 5) break;
                    this.lessonList.push(data.items[i]);
                }

                const result = await this.getLessonListCount();
                this.ticketPrice = 0; // 초기화
                this.ticketCount = data.items.length;
                result.data.items.forEach((g) => {
                    this.ticketPrice += parseInt(g.cc_total_buy_price);
                });
            } catch (error) {
                console.log(error);
            }
        },
        getLessonList() {
            return api.get(`/admin/api/center/${this.centerId}/lesson`, {
                params: {
                    createStartDate: moment(this.startDate).format('YYYYMMDD'),
                    createEndDate: moment(this.startDate).format('YYYYMMDD'),
                    page: 1,
                    limit: 10000,
                },
            });
        },
        getLessonListCount() {
            return api.get(`/admin/api/center/${this.centerId}/lesson`, {
                params: {
                    expireStartDt: moment(this.startDate).format('YYYYMMDD'),
                    expireEndDt: moment(this.startDate).add(7, 'd').format('YYYYMMDD'),
                    ...this.pagingInfo,
                },
            });
        },
        // 오늘의 수업
        async fetchTodayLessonStat() {
            const { data } = await api.get(`/admin/api/dash/board/today/lesson/${this.centerId}`, {
                params: {
                    applyDate: moment(this.startDate).format('YYYYMMDD'),
                },
            });

            this.todayLessonStat = data;
        },
        async getLessonCountByRemainDays(remainDays) {
            const params = {
                lessonRemainDays: remainDays,
                page: 1, // 페이지
                limit: 2, // 한 목록에 표출되는 건수
            }

            const { data } = await api.get(`/admin/api/center/${this.centerId}/lesson`, {
                params,
            });

            this.expiringMemberCount = data.meta.totalItems
        },
        async getInactiveUserCount(inactiveDays) {
            const params = {
                inactiveDays,
                page: 1, // 페이지
                limit: 2, // 한 목록에 표출되는 건수
            }

            const { data } = await api.get(`/admin/api/center/${this.centerId}/customer`, {
                params,
            });

            this.inactiveUserCount = data.meta.totalItems
        },
        async onExpireTicketCount() {
            const { data } = await this.getExpireTicketCount();
            this.todayExpiredCount = data.exp_num;
        },
        getExpireTicketCount() {
            return api.get(`/admin/api/dash/board/expire/ticket/count/${this.centerId}`, {
                params: {
                    applyDate: moment(this.startDate).format('YYYYMMDD'),
                },
            });
        },

        async fetchAttendanceStat() {
            const { data } = await api.get(`/admin/api/center/${this.centerId}/lesson/schedule/customer/attendance/stat`, {
                params: {
                    month: moment().format('YYYYMM'),
                    page: 1,
                    limit: 3,
                },
            });

            this.attendanceStat = data.items;

            while (this.attendanceStat.length < 3) this.attendanceStat.push({});
        },

        convertStatus(type) {
            if (type == 'O') {
                return '진행중';
            } else if (type == 'C') {
                return '완료';
            }
        },
        // 검색 시작일 초기화
        initStartDate() {
            this.startDate = moment().format('YYYY-MM-DD');
        },
        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
            this.init();
        },
        onClickBtnNextMonth() {
            const startDate = moment(this.startDate).add(1, 'days').format('YYYY-MM-DD');
            this.startDate = startDate;
        },
        onClickBtnPrevMonth() {
            const startDate = moment(this.startDate).subtract(1, 'days').format('YYYY-MM-DD');
            this.startDate = startDate;
        },
        formatDay(days) {
            return moment(days).locale('ko').format('dddd');
        },
        convertReserve(type) {
            const index = ['RW', 'RR', 'RC', 'CR', 'WC', 'CC', 'AC'].findIndex((item) => item === type);
            return ['예약대기', '예약', '취소', '변경예약', '대기취소', '변경취소', '취소'][index];
        },
        convertTicket(type) {
            if (type === 'P') {
                return '개인';
            } else if (type === 'D') {
                return '듀엣';
            } else if (type === 'O') {
                return 'OT';
            } else if (type === 'G') {
                return '그룹';
            } else if (type === 'C') {
                return '쿠폰';
            }
        },
        convertLessonTime(time) {
            return moment(time).locale('ko').format('YYYY-MM-DD (dd)');
        },
        convertTime(val) {
            const result = val.split('+');
            return result[0];
        },
        // 오늘의 매출 현황
        async todaySaleStatus() {
            try {
                const { data } = await this.getTodaySaleStatus();
                if (data.items.length == 0) {
                    this.todaySalePrice = 0;
                } else {
                    this.todaySalePrice = 0; // 초기화
                    data.items.forEach((g) => {
                        this.todaySalePrice += g.cc_total_buy_price;
                    });
                }
            } catch (error) {
                console.log(error);
                console.log('error');
            }
        },
        getTodaySaleStatus() {
            return api.get(`/admin/api/center/${this.centerId}/sale/state/sale/today`, {
                params: {
                    page: 1,
                    limit: 10000,
                    startDate: moment(this.startDate).format('YYYYMMDD'),
                    endDate: moment(this.startDate).format('YYYYMMDD'),
                },
            });
        },
        getImageUrl(url) {
            return url || '/img/icons/photo_default.png';
        },
        isSameCurrentDate(date) {
            return moment().format('YYYYMMDD') === moment(date).format('YYYYMMDD');
        },
        async fetchPopupList() {
            try {
                const stopShowTodayList = JSON.parse(localStorage.getItem('stopShowTodayList'));
                const { data } = await this.getPopupList();

                this.popupList = data;
                if (stopShowTodayList && stopShowTodayList.date === moment().format('YYYY-MM-DD')) {
                    for (const id of stopShowTodayList.item) {
                        this.popupList = this.popupList.filter((item) => item.bp_id !== id);
                    }
                } else {
                    localStorage.removeItem('stopShowTodayList');
                }

                for (let i = 0; i < this.popupList.length; i++) {
                    if (i === 0) this.popupList[i].noticePop = true;
                    else this.popupList[i].noticePop = false;
                }
            } catch (error) {
                console.error(error);
            }
        },
        getPopupList() {
            return api.get('/admin/api/board/popup/center/show');
        },
        onClickPopup(index) {
            this.popupList[index].noticePop = false;
            if (index + 1 < this.popupList.length) this.popupList[index + 1].noticePop = true;
            this.$forceUpdate();
        },
        onClickStopShowToday(id, index) {
            let stopShowTodayList = JSON.parse(localStorage.getItem('stopShowTodayList'));
            if (!stopShowTodayList || stopShowTodayList.date !== moment().format('YYYY-MM-DD')) {
                stopShowTodayList = {
                    date: moment().format('YYYY-MM-DD'),
                    item: [],
                };
            }

            stopShowTodayList.item.push(id);
            localStorage.setItem('stopShowTodayList', JSON.stringify(stopShowTodayList));
            this.onClickPopup(index);
        },
        testMethod(testVal, testVal2) {
            let style = '';
            this.testMethod3(testVal) ? (style = 'border: solid 2px #f47e7c;') : (style = '');
            return style;
        },

        testMethod2(testVal) {
            let style = 'day';
            this.testMethod3(testVal) ? (style += ' red') : style;
            return style;
        },

        testMethod3(testVal) {
            let result = false;
            const start = moment().format('YYYYMMDD');
            const end = moment().add(7, 'day');
            result = moment(testVal).isBetween(start, end, '[]');
            return result;
        },
    },
};
</script>

<style lang="scss" scoped>
.box {
  .date {
    color: #666666;
  }

  .info-cnt.people {
    font-size: 22px !important;
  }
}

.attendance {
    .info-cnt {
        text-align: start !important;
        font-size: 16px !important;
    }
}
</style>
